import { render, staticRenderFns } from "./EmployeeCategoryQuickAdd.vue?vue&type=template&id=c44b035e&"
import script from "./EmployeeCategoryQuickAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeCategoryQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports